import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=0779c0bd&scoped=true&"
import script from "./Investment.vue?vue&type=script&lang=ts&"
export * from "./Investment.vue?vue&type=script&lang=ts&"
import style0 from "./Investment.vue?vue&type=style&index=0&id=0779c0bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0779c0bd",
  null
  
)

export default component.exports